"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootReducer = void 0;
const redux_1 = require("redux");
const redux_form_1 = require("redux-form");
const announce_shifts_1 = __importDefault(require("./announce-shifts"));
const auth_1 = __importDefault(require("./auth"));
const availabilities_1 = __importDefault(require("./availabilities"));
const calendar_1 = __importDefault(require("./calendar"));
const calendar_filters_1 = __importDefault(require("./calendar-filters"));
const calendar_multi_select_1 = __importDefault(require("./calendar-multi-select"));
const calendar_search_1 = __importDefault(require("./calendar-search"));
const chat_reducer_1 = __importDefault(require("./chat-reducer"));
const custom_attribute_data_1 = __importDefault(require("./custom-attribute-data"));
const dashboard_1 = __importDefault(require("./dashboard"));
const cycle_detail_1 = __importDefault(require("./cycle-detail"));
const dummy_shift_candidates_1 = __importDefault(require("./dummy-shift-candidates"));
const employee_detail_1 = __importDefault(require("./employee-detail"));
const employees_1 = __importDefault(require("./employees"));
const enforced_locality_1 = __importDefault(require("./enforced-locality"));
const errors_1 = __importDefault(require("./errors"));
const export_token_1 = __importDefault(require("./export-token"));
const forms_1 = __importDefault(require("./forms"));
const fresh_1 = __importDefault(require("./fresh"));
const holidays_1 = __importDefault(require("./holidays"));
const industries_1 = __importDefault(require("./industries"));
const loading_1 = __importDefault(require("./loading"));
const locale_1 = __importDefault(require("./locale"));
const location_1 = __importDefault(require("./location"));
const manager_assistant_1 = __importDefault(require("./manager-assistant"));
const me_1 = __importDefault(require("./me"));
const meta_1 = __importDefault(require("./meta"));
const modal_1 = __importDefault(require("./modal"));
const my_role_1 = __importDefault(require("./my-role"));
const news_feed_1 = __importDefault(require("./news-feed"));
const notifications_1 = __importDefault(require("./notifications"));
const offers_1 = __importDefault(require("./offers"));
const onboarding_1 = __importDefault(require("./onboarding"));
const organization_1 = __importDefault(require("./organization"));
const organization_id_1 = __importDefault(require("./organization-id"));
const performance_columns_1 = __importDefault(require("./performance-columns"));
const performance_data_sources_1 = __importDefault(require("./performance-data-sources"));
const performance_notifications_1 = __importDefault(require("./performance-notifications"));
const positions_1 = __importDefault(require("./positions"));
const reply_1 = __importDefault(require("./reply"));
const shift_detail_1 = __importDefault(require("./shift-detail"));
const shifts_1 = __importDefault(require("./shifts"));
const show_admin_panel_1 = __importDefault(require("./show-admin-panel"));
const sidebar_1 = __importDefault(require("./sidebar"));
const success_1 = __importDefault(require("./success"));
const tables_config_1 = __importDefault(require("./tables-config"));
const tasks_1 = __importDefault(require("./tasks"));
const templates_1 = __importDefault(require("./templates"));
const terminals_1 = __importDefault(require("./terminals"));
const time_offs_1 = __importDefault(require("./time-offs"));
const ui_context_1 = __importDefault(require("./ui-context"));
const user_attributes_1 = __importDefault(require("./user-attributes"));
const user_details_1 = __importDefault(require("./user-details"));
const version_1 = __importDefault(require("./version"));
const workspace_events_1 = __importDefault(require("./workspace-events"));
const workspace_id_1 = __importDefault(require("./workspace-id"));
const workspace_stats_1 = __importDefault(require("./workspace-stats"));
const workspaces_1 = __importDefault(require("./workspaces"));
exports.rootReducer = (0, redux_1.combineReducers)({
    form: redux_form_1.reducer,
    auth: auth_1.default,
    calendar: calendar_1.default,
    calendarSearch: calendar_search_1.default,
    calendarMultiSelect: calendar_multi_select_1.default,
    calendarFilters: calendar_filters_1.default,
    dashboard: dashboard_1.default,
    tablesConfig: tables_config_1.default,
    offers: offers_1.default,
    employeeDetail: employee_detail_1.default,
    userDetails: user_details_1.default,
    employees: employees_1.default,
    errors: errors_1.default,
    exportToken: export_token_1.default,
    fresh: fresh_1.default,
    industries: industries_1.default,
    loading: loading_1.default,
    locale: locale_1.default,
    location: location_1.default,
    managerAssistant: manager_assistant_1.default,
    me: me_1.default,
    modal: modal_1.default,
    myRole: my_role_1.default,
    notifications: notifications_1.default,
    onboarding: onboarding_1.default,
    uiContext: ui_context_1.default,
    positions: positions_1.default,
    reply: reply_1.default,
    shiftDetail: shift_detail_1.default,
    dummyShiftCandidates: dummy_shift_candidates_1.default,
    shifts: shifts_1.default,
    workspaceEvents: workspace_events_1.default,
    holidays: holidays_1.default,
    sidebar: sidebar_1.default,
    success: success_1.default,
    tasks: tasks_1.default,
    templates: templates_1.default,
    terminals: terminals_1.default,
    availabilities: availabilities_1.default,
    timeOffs: time_offs_1.default,
    version: version_1.default,
    enforcedLocality: enforced_locality_1.default,
    workspaceId: workspace_id_1.default,
    workspaceStats: workspace_stats_1.default,
    workspaces: workspaces_1.default,
    organizationId: organization_id_1.default,
    showAdminPanel: show_admin_panel_1.default,
    newsFeed: news_feed_1.default,
    announceShifts: announce_shifts_1.default,
    organization: organization_1.default,
    cycleDetail: cycle_detail_1.default,
    chat: chat_reducer_1.default,
    userAttributes: user_attributes_1.default,
    customAttributeData: custom_attribute_data_1.default,
    meta: meta_1.default,
    performanceColumns: performance_columns_1.default,
    performanceDataSources: performance_data_sources_1.default,
    performanceNotifications: performance_notifications_1.default,
    forms: forms_1.default,
});
